import { Component, OnInit, OnDestroy, Output, EventEmitter, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToDoService } from './todo.service';
import { ToDoItem } from './todo-item';
import { UserService } from '@aifs-shared/user/user.service';
import { Task } from '@aifs-shared/tracker/task';
import { ReferenceService } from '../../reference/reference.service';
import { TrackerService, TrackerTask } from '@aifs-shared/tracker/tracker.service';
import { DisplayCardItem } from '@aifs-shared/display-card/display-card-item';
import { UiModalService } from '@ui/ui-modal.service';
import { CFButtonType } from '@ui/cf-button/cf-button.component';

@Component({
    selector: 'app-todo',
    templateUrl: './todo.component.html',
    styleUrls: ['./todo.component.scss'],
})
export class ToDoComponent implements OnInit, OnDestroy {
    @Output() itemEdit: EventEmitter<ToDoItem> = new EventEmitter();

    private router = inject(Router);
    private userService = inject(UserService);
    private referenceService = inject(ReferenceService);
    private tracker = inject(TrackerService);
    private modalService = inject(UiModalService);
    private todo = inject(ToDoService);

    constructor(
    ) { }

    ngOnInit() {
        this.loading = true;

        const currentState = this.userService.userState();
        const ts = this.tracker.getUserTaskStatusById(TrackerTask.References);

        this.referenceTask = this.tracker.getTaskById(TrackerTask.References) ?? undefined;
        if (this.referenceTask && ts) {
            this.referenceService
                .isAwaitingReferences(currentState, ts.complete)
                .subscribe({
                    next: (yes: boolean) => {
                        this.isAwaitingReferences = yes;
                    },
                    error: (error: any) => {
                        console.error(error);
                    }
                });
        }

        this.todo
            .getToDoForApplication()
            .subscribe({
                next: (r: ToDoItem[]) => {
                    this.loading = false;
                    this.todoItems = r;

                    // 18-935
                    this.hasItems = r && r.length > 0;

                    this.displayItems = [];
                    this.todoItems.forEach(ti => {
                        this.displayItems.push(this.displayItemFromToDoItem(ti));
                    });
                },
                error: (error: any) => {
                    console.error(error);
                    this.loading = false;
                }
            });
    }

    ngOnDestroy() {
    }

    referenceHelp() {
        this.showModal('Awaiting References', 'One or more of your referees have not responded to our reference request. '
            + 'If possible please contact your referee(s) and ask them to complete the reference form. '
            + 'Your application is unable to proceed until you have two approved references. '
            + 'If your referee is unable to complete the reference or you would like to nominate a new referee, please contact us.',
            'Would you like to view your references now?', 'info');
    }

    showModal(title: string, message: string, extra: string | undefined = undefined, cssClass: string = "info") {
        const rt = this.referenceTask;
        console.warn(`Implement UIModalService`);

        if (rt) {
            let extraText = extra != undefined ? `<p>${extra}</p>` : '';
            this.modalService
                .showModalConfirmation(
                    title,
                    `<p>${message}</p>${extraText}`,
                    [
                        { id: 'Y', text: 'Yes', type: CFButtonType.Default },
                        { id: 'N', text: 'No', type: CFButtonType.Cancel },
                    ]
                ).subscribe({
                    next: (r: string) => {
                        if (r === 'Y') {
                            this.tracker.setActiveTask(rt);
                            this.router.navigateByUrl('/references/review');
                        }
                    }
                });
        }
    }

    selectItem(item: DisplayCardItem) {
    }

    editItem(item: DisplayCardItem) {
        let editItem = this.todoItems.find(todo => todo.item == item.id)
        if (!editItem) {
            console.error(`Expected to find item ${item.id} in ${this.todoItems.length} todo items`);
            return;
        }

        if (!editItem.url && editItem.item !== 3) return;

        if (editItem.url.startsWith('http')) {
            window.open(editItem.url, '_blank');
        } else {
            if (editItem.item === 3) {
                // References
                editItem.associatedTask = this.referenceTask;
            }
            this.tracker.setReturnUrl(this.tracker.homeRoute);
            this.itemEdit.emit(editItem);
        }
    }

    displayItemFromToDoItem(ti: ToDoItem): DisplayCardItem {

        let d = new DisplayCardItem({
            id: ti.item,
            title: ti.name,
            details: '',
            editOptionText: 'View',
            canDelete: false,
            canEdit: true
        });

        return d;
    }

    todoItems: ToDoItem[] = [];
    hasItems: boolean = false;
    displayItems: DisplayCardItem[] = [];

    isAwaitingReferences = false;
    referenceTask?: Task;

    loading: boolean = true;
}
